// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_K3C","cls2":"CiterightInline-cls2_Nqa CiterightInline-cls1_K3C"};